import React from "react";
import { Hero } from "./components/Hero";
import { Testimonials } from "./components/Testimonials";
import { PainPoints } from "./components/PainPoints";
import { Tomos } from "./components/Tomos";
import { Bonos } from "./components/Bonos";
import { Offer } from "./components/Offer";
import { CostComparison } from "./components/CostComparison";
import { Timeline } from "./components/Timeline";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans" data-id="element-0" data-mp="2mndqegsza4vl">
      <Hero data-id="element-1" data-mp="31b8l22qjqjbb" />
      <main data-id="element-2" data-mp="31ayvgg9eye65">
        <Testimonials data-id="element-3" data-mp="31bi9hlvy0iew" />
        <PainPoints data-id="element-4" data-mp="31c1l6kv02akh" />
        <Tomos data-id="element-5" data-mp="2wk08wyxu0jug" />
        <Bonos data-id="element-6" data-mp="2wjgqlh49rtfw" />
        <Offer data-id="element-7" data-mp="2wjql9i09eorx" />
        <CostComparison data-id="element-8" data-mp="2wj8f9tnsow6t" />
        <Timeline data-id="element-9" data-mp="2whx95n6vnccj" />
        <FinalCta data-id="element-10" data-mp="28ufo0ai4bcij" />
      </main>
      <Footer data-id="element-11" data-mp="28tmej1rry8wp" />
    </div>;
}